import { useLazyQuery, useMutation } from '@apollo/client';
import images from '../../assets/images';
import './Workshop.scss';
import { GET_ALL_SCHEDULED_WORKSHOPS, GET_ALL_WORKSHOPS_VIDEOS, GET_WORKSHOP_BY_ID, SCHOOL_ADMIN_WORKSHOP, UPDATE_PLAY_BACK_TIME, UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, UPDATE_WORKSHOP_MEETING_ID, UPLOAD_WORKSHOP_VIDEO } from './api/WorkshopQuery';
import { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import CreateSchedule from '../../components/CreateSchedule/CreateSchedule';
import WorkshopLibrary from '../../components/WorkshopLibrary/WorkshopLibrary';
import dayjs from 'dayjs';
import ToasterWithMessage from '../../components/toaster';
import { JITSI, SCHOOL_ADMIN, TEACHER_ROLE } from '../../utils/constants';
import { useAppSelector } from '../../redux/app/hooks';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import FileUpload from '../../components/Popups/FileUpload';
import { debounce } from 'lodash';
import { useDispatch } from 'react-redux';
import { setCurrentSessionDetail, setCurrentSessionRecordingDetail, setCurrentVideoData, setCurrentWorkshopId, setMeetComponentName } from '../../redux/slices/dashboardSlice';
import { visibility } from '../../redux/slices/rightSideAd';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { getScreenDimensions } from '../../utils/helper';
import MobileHeader from '../../components/MobileHeader/MobileHeader';
import { generateUniqueMeetingId } from '../../utils/helper';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';
import { Tooltip } from '@mui/material';

export interface clickedWorkshopDetails{
    type?: "workshop",
    isActive: boolean,
    wsDescription: string,
    wsTopic: string,
    wsId: string,
    wsEndTime: string,
    wsInteractionsPeriod: string,
    wsTeachingPeriod:string,
    wsStartTime: string,
    wsStatus: string,
    wsCode: string,
    hostId?: string,
    isRecordStart: boolean,
    recordStartTime:string| null,
    wsParticipantsCount: number;
    feedsByWsId: {
        nodes: [
            {
                fId: string;
            }
        ]
    }
    serverUrl?: string | null;
    botUrl?: string | null;
    meetingType?: string | null;
    participantIds: string[]
}

interface subType{
    wsDescription: string
}

export interface singleObjectType{
    seId: string,
    seDescription: string,
    createdAt: string,
    seUrl: string,
    seType: string,
    sePlaybackTime: string | null,
    workshopByWsId: subType | null,
    videosPlaybacktimesBySeId: videoPlayBackType,
}

export interface videoPlayBackType{
    nodes: videoPlayBackNodeType[]
}

export interface videoPlayBackNodeType {
    playbackTime: string,
    vpId: string,
}
export interface workshopVideosType{
    nodes: singleObjectType[],
    totalCount: number
}

const Workshop: FunctionComponent = () => {
    
  const {error} = ToasterWithMessage();
  const {backArrow, searchIcon, uploadCloud, ScheduleWorkshopGif, BluePlayButton, whiteCrossIcon, searchCloseIcon, plusIcon} = images;
  const [showCreateScheduling, setShowCreateScheduling] = useState<boolean>(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [singleSessionDetail,setSingleSessionDetail] = useState<clickedWorkshopDetails>();
  const [clickedSessionDetails,setClickedSessionDetails] = useState<clickedWorkshopDetails>();
  const [isClickedSessionDetail,setIsClickedSessionDetail] = useState<boolean>(false);
  const [isDeleted,setIsDeleted] = useState<boolean>(false);
  const [liveSessionsList,setLiveSessionsList] = useState<clickedWorkshopDetails[]>([]);
  const [sessionEnded, setSessionEnded] = useState<boolean>(false);
  const [isWorkshopUploadOpen, setIsWorkshopUploadOpen] = useState<boolean>(false);
  const [workshopOpen, setWorkshopOpen] = useState<boolean>(false);
  const [workshopDescription, setWorkshopDescription] = useState<string>();
  const [videoUrl, setVideoUrl] = useState<string>();
  const [videoFileName, setVideoFileName] = useState<string>();
  const [videoFileData, setVideoFileData] = useState<File | null>();
  const [workshopUploaded, setWorkshopUploaded] = useState(false);
  const [workshopUploadFailed, setWorkshopUploadFailed] = useState<boolean>(false);
  const [workshopUploadProgress, setWorkshopUploadProgress] = useState(0);
  const [workshopUploadFileName, setWorkshopUploadFileName] = useState<string>('');
  const [allSavedUploadedVideosList,setAllSavedUploadedVideosList] = useState<singleObjectType[]>();
  const [refetch, SetRefetch] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isVideoUploaded, setIsVideoUploaded] = useState<boolean>(false);
  const [clickedVideoUrl,setClickedVideoUrl] = useState<string>('');
  const [clickedVideoDescription, setClickedVideoDescription] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [clickedVideoData, setClickedVideoData] = useState<singleObjectType | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const clickedVideoRefValue = useAppSelector((state) => state.dashboard.clickedVideoData);
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const [isAdminButtonClicked, setIsAdminButtonClicked] = useState<boolean>(false);
  const [isTeacherButtonClicked, setIsTeacherButtonClicked] = useState<boolean>(false);
  const [isMoreClick,SetIsMoreClick] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const [initialLoading, setInitialLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [overallCount, setOverallCount] = useState<number>(0);
  const pageSize = 15;
  const { createMeeting, joinMeeting, setIsRecording, setRecordingStartTime } = useChimeMeeting();
  const navigate = useNavigate();
  const {state} = useLocation();
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;


  const dispatch = useDispatch();
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const { role, meetService } = useAppSelector((state) => state.auth);
  const meetingService = meetService;
  console.log("[log] Workshop", meetingService);
  
    
const [getAllScheduledWorkshops, {loading}] = useLazyQuery(GET_ALL_SCHEDULED_WORKSHOPS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setLiveSessionsList(data?.getAllWorkShops);
      setClickedSessionDetails(undefined);
      setIsClickedSessionDetail(false);
      setIsDeleted(false);
    },
    onError: (err) => {
        error(err?.message);
    }
  });


  const [ getAllWorkshopsVideos, {loading: getAllVideoLoading} ] = useLazyQuery(GET_ALL_WORKSHOPS_VIDEOS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setOffset((prev) => prev + pageSize);
      setTotalCount(data?.allWorkshopSessions?.totalCount);
      setOverallCount(data?.overAllCount?.totalCount);
      setAllSavedUploadedVideosList((prevFeeds: any) => {
        const updatedVideos = initialLoading ? data?.allWorkshopSessions?.nodes : [...prevFeeds, ...data?.allWorkshopSessions?.nodes];
        setHasMore(updatedVideos.length < (data?.allWorkshopSessions?.totalCount ?? 0));
        return updatedVideos;
      });
      if (initialLoading) {
        setInitialLoading(false);
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ getSchoolAdminWorkshop, {loading: getSchoolAdminWorkshopLoading} ] = useLazyQuery(SCHOOL_ADMIN_WORKSHOP, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setOffset((prev) => prev + pageSize);
      setTotalCount(data?.allWorkshopSessions?.totalCount);
      setOverallCount(data?.overAllCount?.totalCount);
      setAllSavedUploadedVideosList((prevFeeds: any) => {
        const updatedVideos = initialLoading ? data?.allWorkshopSessions?.nodes : [...prevFeeds, ...data?.allWorkshopSessions?.nodes];
        setHasMore(updatedVideos.length < (data?.allWorkshopSessions?.totalCount ?? 0));
        return updatedVideos;
      });
      if (initialLoading) {
        setInitialLoading(false);
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [updatePlayBackTime] = useMutation(UPDATE_PLAY_BACK_TIME, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        SetRefetch(!refetch);
        dispatch(setCurrentVideoData({
            videoCurrentTime: 0,
            videoId: ''
        }));
    },
    onError: (err) => {
        error(err?.message);
    }
});


// const [updateSessionParticipantCount] = useMutation(UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, {
//     fetchPolicy: "no-cache",
//     onCompleted: (data) => {},
//     onError: (err) => {}
//   });

  const [updateSessionId] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        fetchSessionDetails();
    },
    onError: (err) => {
      setIsAdminButtonClicked(false);
    }
});

const fetchSessionDetails = () => {
    if (singleSessionDetail) {
        getSingleSession({
            variables: {
                input: {
                    wsId: singleSessionDetail?.wsId
                }
            }
        })
    }
  };

const [getSingleSession] = useLazyQuery(GET_WORKSHOP_BY_ID, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        let response = data?.getWorkShopByWsId || {};
        const meetId = response?.wsCode;

        if (meetId && meetingService !== JITSI) {
            getChimeParticipants(meetId)
                .then((participantsResponse) => {
                    response.wsParticipantsCount = participantsResponse?.Attendees ? participantsResponse.Attendees.length : 0;
                })
                .catch(() => {
                    response.wsParticipantsCount = 0;
                })
                .finally(() => {
                    console.log("[Log] Participants count:", response.wsParticipantsCount);
                    if (isMoreClick === false) {
                        //this state is using for start and join session card place
                        setSingleSessionDetail(response);
                    } else {
                        //this state is using for edit and delete session
                        setClickedSessionDetails({ ...response, type: "workshop" });
                    }
                });
        } else {
            if (isMoreClick === false) {
                //this state is using for start and join session card place
                setSingleSessionDetail(response);
            } else {
                //this state is using for edit and delete session
                setClickedSessionDetails({ ...response, type: "workshop" });
            }
        }
        setSessionEnded(false);
    },
    onError: (err) => {
    if(err?.message === "Workshop has ended"){
         setSessionEnded(true);
         setTimeout(() => {
          setSingleSessionDetail(undefined);
          fetchUpcomingSessions();
        }, 5000); 
      }else {
        error(err?.message)
      }
    }
  });
  

    const handleStartMeeting = async (stream?: any) => {
        dispatch(setMeetComponentName({ meetComponent: 'workshop' }));
        if (meetingService === JITSI) {
            // Check for Jitsi server url
            if (!singleSessionDetail?.serverUrl) {
                error("Meeting Server setup in progress.");
                setIsAdminButtonClicked(false);
                return;
            }

            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            const userName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
            const meetingId = generateUniqueMeetingId();

            try {
                // updateSessionId({
                //     variables: {
                //         updateInput: {
                //             wsCode: meetingId,
                //             wsStatus: "STARTED",
                //             hostId: userId,
                //         },
                //         wsId: singleSessionDetail?.wsId
                //     }
                // })
                if (singleSessionDetail?.wsId) {
                    dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                    dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.wsStartTime, endDate: singleSessionDetail?.wsEndTime }));
                    dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
                }
                navigate(`/admin-workshop/meeting?meetId=${meetingId}`, { state: { ...state, meetingId: meetingId, userName: userName, isHost: true, isCreateMeeting: true, hostId: userId, userId, meetComponent: 'workshop', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
            }
            catch (e) {
                setIsAdminButtonClicked(false);
            }
        }
        else {
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            await createMeeting(userId).then(async (response) => {
                console.log('[Log] createMeeting response', response);
                const meetId = response?.Meeting?.MeetingId;
                // const data = await response.json();
                if (meetId) {
                    //  const {meetId, user, host, createdAt} = data.meetInfo;
                    try {
                        // await InitialiseMeeting({
                        //     meetId,
                        //     avatar: getRandomColor(),
                        //     currentUser: {
                        //         userId: user.userId,
                        //         avatarKey: user.avatarKey,
                        //         userKey: user.userKey,
                        //         userName: user.userName,
                        //         preference: {
                        //             audio: true,
                        //             video: true,
                        //             screen: false,
                        //             hand: false
                        //         },
                        //         isPinned: {video: false, screen: false}
                        //     },
                        //     host:{
                        //         hostId: host.hostId,
                        //         hostKey: host.hostKey,
                        //         hostName: host.hostName
                        //     },
                        //     createdAt
                        // }, FormType.CREATE);
                        // await updateSessionParticipantCount({
                        //     variables: {
                        //         input: {
                        //             participantType: true,
                        //             wsId: singleSessionDetail?.wsId
                        //         }
                        //     }
                        // })
                    } catch (err) {
                        setIsAdminButtonClicked(false);
                    }

                    updateSessionId({
                        variables: {
                            updateInput: {
                                wsCode: meetId,
                                wsStatus: "STARTED",
                                hostId: userId,
                            },
                            wsId: singleSessionDetail?.wsId
                        }
                    })
                    if (singleSessionDetail?.wsId) {
                        dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                        dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.wsStartTime, endDate: singleSessionDetail?.wsEndTime }));
                        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
                    }                
                    navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                    }
            }).catch((error) => {
                setIsAdminButtonClicked(false);
                stream.getAudioTracks()[0].stop();
                stream.getVideoTracks()[0].stop();
            });
        }
    };

    const handleJoinMeeting = async (stream?: any) => {
        dispatch(setMeetComponentName({ meetComponent: 'workshop' }));
        if (meetingService === JITSI) {
            // Check for Jitsi server url
            if (!singleSessionDetail?.serverUrl) {
                error("Meeting Server setup in progress.");
                if (role === SCHOOL_ADMIN) {
                    setIsAdminButtonClicked(false);
                } else if (role === TEACHER_ROLE) {
                    setIsTeacherButtonClicked(false);
                }
                return;
            }
            
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            const userName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;

            try {
                if (singleSessionDetail?.wsId) {
                    dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                    dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.wsStartTime, endDate: singleSessionDetail?.wsEndTime }));
                    dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
                    setRecordingStartTime(singleSessionDetail?.recordStartTime);
                    setIsRecording(singleSessionDetail?.isRecordStart);
                }
                if (role === SCHOOL_ADMIN) {
                    navigate(`/admin-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, { state: { ...state, meetingId: singleSessionDetail?.wsCode, userName: userName, isHost: singleSessionDetail?.hostId && userId === singleSessionDetail.hostId, isCreateMeeting: false, hostId: singleSessionDetail?.hostId, userId, meetComponent: 'workshop', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
                } else if (role === TEACHER_ROLE) {
                    navigate(`/teacher-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, { state: { ...state, meetingId: singleSessionDetail?.wsCode, userName: userName, isHost: false, isCreateMeeting: false, hostId: singleSessionDetail?.hostId, userId, meetComponent: 'workshop', jitsiUrls: { jitsiMeetUrl: singleSessionDetail?.serverUrl, jitsiBotUrl: singleSessionDetail?.botUrl } } });
                }
            }
            catch (err) {
                if (role === SCHOOL_ADMIN) {
                    setIsAdminButtonClicked(false);
                } else if (role === TEACHER_ROLE) {
                    setIsTeacherButtonClicked(false);
                }
            }
        }
        else {
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;

            if (singleSessionDetail?.wsCode && singleSessionDetail?.hostId) {
                await joinMeeting(singleSessionDetail.wsCode, userId, singleSessionDetail.hostId)
                    .then(async (response) => {
                        console.log('[Log] joinMeeting response', response);
                        const meetId = response?.meetingResponse?.Meeting?.MeetingId;
                        //  const data = await response.json();
                        if (meetId) {
                            //  const {meetId, user, host, createdAt} = data.meetInfo;
                            try {
                                // await InitialiseMeeting({
                                //     meetId,
                                //     avatar: getRandomColor(),
                                //     currentUser: {
                                //         userId: user.userId,
                                //         avatarKey: user.avatarKey,
                                //         userKey: user.userKey,
                                //         userName: user.userName,
                                //         preference: {
                                //             audio: true,
                                //             video: true,
                                //             screen: false,
                                //             hand: false
                                //         },
                                //         isPinned: {video: false, screen: false}
                                //     },
                                //     host:{
                                //         hostId: host.hostId,
                                //         hostKey: host.hostKey,
                                //         hostName: host.hostName
                                //     },
                                //     createdAt
                                // }, FormType.JOIN);
                                // await updateSessionParticipantCount({
                                //     variables: {
                                //         input: {
                                //             participantType: true,
                                //             wsId: singleSessionDetail?.wsId
                                //         }
                                //     }
                                // })
                            } catch (err) {
                                if (role === SCHOOL_ADMIN) {
                                    setIsAdminButtonClicked(false);
                                } else if (role === TEACHER_ROLE) {
                                    setIsTeacherButtonClicked(false);
                                }
                            }
                            if (singleSessionDetail?.wsId) {
                                dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                                dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.wsStartTime, endDate: singleSessionDetail?.wsEndTime }));
                                dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
                                setRecordingStartTime(singleSessionDetail?.recordStartTime);
                                setIsRecording(singleSessionDetail?.isRecordStart);
                            }
                            if (role === SCHOOL_ADMIN) {
                                navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                            } else if (role === TEACHER_ROLE) {
                                navigate(`/teacher-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                            }
                        }
                    }).catch(() => {
                        if (role === SCHOOL_ADMIN) {
                            setIsAdminButtonClicked(false);
                        } else if (role === TEACHER_ROLE) {
                            setIsTeacherButtonClicked(false);
                        }
                        stream.getAudioTracks()[0].stop();
                        stream.getVideoTracks()[0].stop();
                    })
            }
        }
    };

useEffect(() => {
    if(clickedVideoData?.seId && clickedVideoUrl && clickedVideoRefValue?.videoCurrentTime){
        updatePlayBackTime({
            variables: {
                input: {
                    videosPlaybacktime: {
                        seId: clickedVideoData?.seId,
                        uId: profile.getCurrentUser.nodes[0].uId,
                        playbackTime: clickedVideoRefValue?.videoCurrentTime.toString()
                    }
                }
            }
        });
    }
   
},[clickedVideoRefValue]);


useEffect(() => {

    if(clickedVideoData?.videosPlaybacktimesBySeId?.nodes[0]?.playbackTime && videoRef.current){
        videoRef.current.currentTime = parseFloat(clickedVideoData?.videosPlaybacktimesBySeId?.nodes[0]?.playbackTime);
    }
},[clickedVideoData]);

const handleOnMouseOut = () => {
    if(videoRef.current){
      dispatch(setCurrentVideoData({
        videoCurrentTime: videoRef.current.currentTime,
        videoId: clickedVideoData?.seId ? clickedVideoData?.seId : ''
      }))
    }
}

  const showNoWorkshopsDiv = (!(liveSessionsList?.length > 0) && !(allSavedUploadedVideosList && totalCount > 0)&& !(showCreateScheduling) && !loading && !(getAllVideoLoading || getSchoolAdminWorkshopLoading) && !isVideoUploaded && overallCount === 0);


  //To upload the video
  const [uploadWorkshopVideo] = useMutation(UPLOAD_WORKSHOP_VIDEO, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        if (data?.createWorkshopSession) {
            setIsVideoUploaded(true);
            setVideoFileData(null);
            if (videoFileName) {
                setWorkshopUploadFileName(videoFileName);
            }
            setWorkshopUploaded(true);
            setWorkshopDescription('');
            setWorkshopUploadProgress(100);
            setVideoFileName('');
            setVideoUrl('');
            SetRefetch(!refetch);
        }
    },
    onError: (err) => {
        setIsVideoUploaded(false);
        if (videoFileName) {
            setWorkshopUploadFileName(videoFileName);
        }
        setWorkshopUploaded(true);
        setWorkshopUploadProgress(0);
        setWorkshopUploadFailed(true);
    }
});

const fetchUpcomingSessions = () => {
    const currentDateUTC = dayjs().utc().format();

    getAllScheduledWorkshops({
        variables: {
            input: {
                startDate: currentDateUTC,
                isFacilitator: false
            },
        }
    })
  }

  const handleClickScheduleMeeting = () => {
      if(role === SCHOOL_ADMIN){
        setShowCreateScheduling(true);
      }
  }

  const handleBackArrowAction = (prevVideoRef: any = null) => {
    if(showCreateScheduling){
        setShowCreateScheduling(false);
    } 
    if(singleSessionDetail?.wsId){
        setSingleSessionDetail(undefined);
    }
    if(isClickedSessionDetail){
        setIsClickedSessionDetail(true);
    }
    if(editClicked){
        setEditClicked(false);
    }
    if(clickedVideoUrl){
        if(prevVideoRef){
            updatePlayBackTime({
                variables: {
                    input: {
                        videosPlaybacktime: {
                            seId: clickedVideoData?.seId,
                            uId: profile.getCurrentUser.nodes[0].uId,
                            playbackTime: prevVideoRef?.currentTime.toString()
                        }
                    }
                }
            });
        }
        setClickedVideoUrl('');
        setClickedVideoDescription('');
        setClickedVideoData(null);
    }
  }

  const handleClickUploadIcon = () => {
        setIsWorkshopUploadOpen(true);
        setWorkshopOpen(true);
  }

  const onClickCloseIcon = (event: any, prevVideoRef: any) => {
    if(prevVideoRef){
        updatePlayBackTime({
            variables: {
                input: {
                    videosPlaybacktime: {
                        seId: clickedVideoData?.seId,
                        uId: profile.getCurrentUser.nodes[0].uId,
                        playbackTime: prevVideoRef?.currentTime.toString()
                    }
                }
            }
        });
    }
    setClickedVideoUrl('');
    setClickedVideoDescription('');
    setClickedVideoData(null);
  }


  const handleSearchDebounce = useCallback(
    debounce((value, active) => {
        setSearchValue(value);
        setAllSavedUploadedVideosList([])
        setOffset(0);
        if (role === SCHOOL_ADMIN) {
            getSchoolAdminWorkshop({
                variables: {
                    searchInput: `%${value.trim()}%`,
                    limit: null,
                    offset: 0,
                    seType: active === 1 ? ['SAVED'] : active === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
                }
            })
        }
        else {
            getAllWorkshopsVideos({
                variables: {
                    searchInput: `%${value.trim()}%`,
                    limit: null,
                    offset: 0,
                    seType: active === 1 ? ['SAVED'] : active === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
                }
            })
        }
    }, 500),
    [getAllWorkshopsVideos, getSchoolAdminWorkshop]
);


const searchOnChange = (event: { target: { value: any; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce)
        handleSearchDebounce(event?.target?.value, activeTab);
}

  useEffect(() => {
        setIsMeetingEndByHost(false);
      dispatch(visibility({ isVisible: false }));
        dispatch(setCurrentSessionDetail({startDate: null, endDate: null}))
        dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: null, recordingStarted: false}));
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
  }, [])

  useEffect(() => {
    if(!isClickedSessionDetail){
      fetchUpcomingSessions();
    }
  },[isClickedSessionDetail, setIsClickedSessionDetail]);

  useEffect(() => {
    if (!showCreateScheduling || isDeleted) {
      fetchUpcomingSessions();
    }
  }, [showCreateScheduling, isDeleted]);
  

  useEffect(() => {
    setOffset(0);
    setAllSavedUploadedVideosList([]);
    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: 0,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: 0,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
}, [refetch]);

useEffect(() => {
    setInitialLoading(true);
    setOffset(0);
}, [])


const loadMore = useCallback(() => {
    if (getAllVideoLoading || getSchoolAdminWorkshopLoading || !hasMore) return;
    
    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
  }, [ hasMore, offset, getAllWorkshopsVideos, getAllVideoLoading, getSchoolAdminWorkshop, getSchoolAdminWorkshopLoading]);

useEffect(() => {

    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }

},[activeTab])

useEffect(() => {
    if (videoFileData && videoFileName && videoFileName !== '' && videoUrl && workshopDescription) {
       uploadWorkshopVideo({
        variables: {
            input: {
                seDescription: workshopDescription?.trim(),
                seTitle: videoFileName?.trim(),
                seUrl: videoUrl,
                seType: "UPLOADED",
                saId: profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saId
              }
        }
       })
    }
}, [videoFileData, videoFileName, videoUrl, workshopDescription]);


useEffect(() => {
    if (!clickedVideoUrl && showCreateScheduling) {
        dispatch(visibility({ isVisible: true }));
    }
    else {
        dispatch(visibility({ isVisible: false }));
    }
},[clickedVideoUrl, showCreateScheduling])

const handleSearchClick = () => {
    setisSearchClick(true);
}

const handleCloseSearch = () => {
    setisSearchClick(false);
    setSearchValue("");
    handleSearchDebounce("", activeTab);
}

const textRef = useRef<HTMLDivElement>(null);
const [isEllipsisActive, setIsEllipsisActive] = useState(false);

// Function to check if text is truncated
const checkEllipsis = useCallback(() => {
  if (textRef.current) {
    setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
  }
}, []);

useEffect(() => {
  checkEllipsis(); // Check on mount
  window.addEventListener("resize", checkEllipsis); // Recheck on resize

  return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
}, [checkEllipsis]);

// Recheck ellipsis on hover
const handleMouseEnter = () => {
  checkEllipsis();
};

  return (
    <div className='workshopMainContainer' style={{gap: showCreateScheduling ? '10px' : '', paddingBottom: showCreateScheduling ? '46px' : ''}}>
        {
                ((!loading && !(getAllVideoLoading || getSchoolAdminWorkshopLoading) && (showCreateScheduling)) || clickedVideoUrl) ?
                <div className='backArrowContainer' onClick={() => {
                    let prevVideoRef;
                    if(videoRef.current){
                        prevVideoRef = {
                            currentTime: videoRef.current.currentTime
                        }
                    }
                    handleBackArrowAction(prevVideoRef);
                }}>
                        <img
                            className="backArrow"
                            alt="back-arrow"
                            src={backArrow}
                        />
                        {clickedVideoUrl && <Tooltip title={isEllipsisActive ? clickedVideoDescription ?? "" : ""} disableHoverListener={!isEllipsisActive}>
          <div ref={textRef} className="videoDescriptionStyle" onMouseEnter={handleMouseEnter}>
            {clickedVideoDescription}
          </div>
        </Tooltip>}
                </div>
                : <></>
        }
        {
                ((!loading) && clickedVideoUrl &&  !(getAllVideoLoading || getSchoolAdminWorkshopLoading)) || (showCreateScheduling)
                ? <></>
                :
                <>
                    {getScreenDimensions()?.isMobileScreen && !isSearchClick && !singleSessionDetail?.wsId && 
                        <MobileScreenHeader
                            handleSearchClick={handleSearchClick}
                            profileImage={profileImage}
                            role={role}
                            studentName={StudentName}
                            profile={profile}
                        />
                    } 
                    <div className={`workshopHeader ${(singleSessionDetail?.wsId && !isSearchClick && getScreenDimensions()?.isMobileScreen) ? "mobileWorkshopHeader" : ""}`}>        
                        <div className='workshopTitleContainer'>
                                {
                                    (singleSessionDetail?.wsId && !isSearchClick) ?
                                    <div className='backArrowContainer' onClick={handleBackArrowAction}>
                                        <img
                                            className="backArrow"
                                            alt="back-arrow"
                                            src={backArrow}
                                        />
                                    </div>
                                    : <></>
                                }
                                
                            {((!isSearchClick && getScreenDimensions()?.isMobileScreen) || (!getScreenDimensions()?.isMobileScreen)) && (
                                <div className='titlesStyle'>
                                    <div className='workshopMainTitle'>{'Workshop Library'}</div>
                                    <div className='workshopSubTitle'>Learn how others are improving</div>
                                </div>
                            )}
                        </div>
                        {getScreenDimensions()?.isMobileScreen && !isSearchClick && singleSessionDetail?.wsId && <MobileHeader handleSearchClick={handleSearchClick} />}
                        {
                        (!(singleSessionDetail?.wsId && role === TEACHER_ROLE) && ((getScreenDimensions()?.isMobileScreen && isSearchClick) || (liveSessionsList?.length > 0) || isVideoUploaded || (allSavedUploadedVideosList && totalCount > 0) || overallCount > 0))  ?
                            <div className={`workshopSearch ${(getScreenDimensions()?.isMobileScreen && isSearchClick) ? 'mobileSearch' : ''}`}>
                                <div className='SearchIconContainer'><img src={searchIcon} alt='searchIcon' className='commonSearchIconStyle' /></div>
                                <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue} className='SearchInputFieldStyle' />
                                {(getScreenDimensions()?.isMobileScreen && isSearchClick) && <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />}
                            </div>
                        : <></>
                        }
                        <div className='createScheduleButtonContainer' style={{ display: (singleSessionDetail?.wsId || isSearchClick) ? "none" : "flex", visibility: (role === SCHOOL_ADMIN) ? 'visible' : 'hidden'}}>
                            {
                                (singleSessionDetail?.wsId) &&  !isVideoUploaded ?
                                <></>
                                : (allSavedUploadedVideosList && totalCount === 0) && (liveSessionsList?.length === 0) && (overallCount === 0) ?
                                <></>
                                :
                                <button className='scheduleMeetBtnStyle' onClick={handleClickScheduleMeeting}>
                                    {getScreenDimensions()?.isMobileScreen ? <img src={plusIcon} alt='plusicon'/>  : "Schedule meeting"}
                                </button>
                            }
                                <div className='workshopUploadContainer' style={{ visibility : (role === SCHOOL_ADMIN) ? 'visible' : 'hidden'}} onClick={handleClickUploadIcon}>
                                {/* <div className='workshopUploadContainer'> */}
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                        </div>
                    </div>
                </>
        }
        {
                // (!loading) && (singleSessionDetail?.wsId && role === TEACHER_ROLE) ?
                // <JoinWorkshop setSingleSessionDetail={setSingleSessionDetail} singleSessionDetail ={singleSessionDetail}/>
                // :
                <div 
                    className='workshopContentContainer'
                    style={{
                        marginBottom: showNoWorkshopsDiv ? '100px' : '',
                        flexDirection: showCreateScheduling ? 'column' : 'unset',
                        alignItems: showCreateScheduling ? 'center' : 'unset'
                    }}
                >
                    {(loading || getAllVideoLoading || getSchoolAdminWorkshopLoading) && !clickedVideoUrl && !hasMore && <Loader bottom='90px'/>}
                    {
                    showNoWorkshopsDiv
                    ?
                        <div className='NoWorkshops'>
                                <img alt='gif' src={ScheduleWorkshopGif} className='scheduleMeetGifStyle'/>
                                <div className='ctaStyle' style={{ cursor: ( role === SCHOOL_ADMIN) ? 'pointer' : 'default' }} onClick={handleClickScheduleMeeting}>
                                    {(role === SCHOOL_ADMIN) && <img alt='playBtn' src={BluePlayButton} className='playButtonStyle'/>}
                                    <div className='textStyle'>{(role === SCHOOL_ADMIN) ? `Schedule Meeting` : `No Workshops Created Yet!`}</div>
                                </div>
                        </div>
                    : (!clickedVideoUrl && showCreateScheduling) 
                    ? <></>
                    : 
                        ((!loading && !(getAllVideoLoading || getSchoolAdminWorkshopLoading) && !clickedVideoUrl) || (hasMore && !clickedVideoUrl)) && 
                            <WorkshopLibrary
                                setEditClicked={setEditClicked}
                                setClickedVideoUrl = {setClickedVideoUrl} 
                                setClickedVideoData={setClickedVideoData}
                                setClickedVideoDescription = {setClickedVideoDescription}
                                allSavedUploadedVideosList = {allSavedUploadedVideosList} 
                                setSingleSessionDetail={setSingleSessionDetail} 
                                singleSessionDetail={singleSessionDetail} 
                                upcomingSessionList = {liveSessionsList} 
                                setShowCreateScheduling = {setShowCreateScheduling}
                                setClickedSessionDetails={setClickedSessionDetails}
                                clickedSessionDetails= {clickedSessionDetails}
                                setIsDeleted={setIsDeleted}
                                fetchUpcomingSessions={fetchUpcomingSessions}
                                setIsClickedSessionDetail={setIsClickedSessionDetail}
                                isClickedSessionDetail={isClickedSessionDetail}
                                setSessionEnded = {setSessionEnded}
                                sessionEnded = {sessionEnded}
                                loading = {loading}
                                activeTab = {activeTab}
                                setActiveTab = {setActiveTab}
                                getAllVideoLoading={getAllVideoLoading || getSchoolAdminWorkshopLoading}
                                setIsAdminButtonClicked = {setIsAdminButtonClicked}
                                isAdminButtonClicked = {isAdminButtonClicked}
                                setIsTeacherButtonClicked = {setIsTeacherButtonClicked}
                                isTeacherButtonClicked = {isTeacherButtonClicked}
                                SetIsMoreClick = {SetIsMoreClick}
                                isMoreClick = {isMoreClick}
                                handleStartMeeting = {handleStartMeeting}
                                handleJoinMeeting = {handleJoinMeeting}
                                fetchSessionDetails = {fetchSessionDetails}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                setHasMore={setHasMore}
                                totalCount={totalCount}
                                setAllSavedUploadedVideosList={setAllSavedUploadedVideosList}
                                setOffset={setOffset}
                                handleClickScheduleMeeting={handleClickScheduleMeeting}
                                isVideoUploaded={isVideoUploaded}
                                isSearchClick={isSearchClick}
                            />
                    }
                    {/* for mobile screen */}
                    {(!isSearchClick && getScreenDimensions()?.isMobileScreen && !(loading || clickedVideoUrl || getAllVideoLoading || getSchoolAdminWorkshopLoading) && !(showCreateScheduling || (singleSessionDetail?.wsId && (role === TEACHER_ROLE)))) && (
                        <div className='workshopUploadContainerMobile' style={{ visibility : role === SCHOOL_ADMIN ? 'visible' : 'hidden'}} onClick={handleClickUploadIcon}>
                            <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>
                    )}
                    {
                        !clickedVideoUrl && showCreateScheduling ?
                        <CreateSchedule 
                            setShowCreateScheduling={setShowCreateScheduling} 
                            clickedSessionDetails={clickedSessionDetails}
                            component={"workshop"}
                            setEditClicked={setEditClicked}
                            editClicked={editClicked}
                        />
                        : <></>
                    }
                </div>
        }
        {
            clickedVideoUrl && 
            <div className='detailView'>
                <video 
                    src={clickedVideoUrl} 
                    ref={videoRef}
                    onMouseOut={handleOnMouseOut}
                    autoPlay 
                    disablePictureInPicture 
                    controls 
                    controlsList='nodownload noplaybackrate' 
                    loop 
                    className='detailVideoTagStyle' 
                    style={{outline: 'none', border: 'none', objectFit: 'contain', backgroundColor: '#3a3a3a' }}
                />
                <img alt="closeIcon" src={whiteCrossIcon} className={(role === SCHOOL_ADMIN) ? 'adminWhiteCrossIcon':'whiteCrossIcon'} onClick={(event) => {
                    let prevVideoRef;
                    if(videoRef.current) {
                        prevVideoRef = {
                            currentTime : videoRef.current.currentTime
                        }
                    }
                    onClickCloseIcon(event, prevVideoRef);
                }} />
            </div>
        }
        {/* {
            clickedVideoUrl && <img src={whiteCrossIcon} className={'whiteCrossIcon'} onClick={onClickCloseIcon}/>
        }    */}
        {isWorkshopUploadOpen && <FileUpload name = "workshopVideo" type='video' setWorkshopDescription = {setWorkshopDescription} setUrl={setVideoUrl} open={workshopOpen} setOpen={setWorkshopOpen}  setIsUploadOpen={setIsWorkshopUploadOpen} folderName="materials" setFilename={setVideoFileName} setFileData={setVideoFileData} setUploadFailed={setWorkshopUploadFailed} setUploadProgress={setWorkshopUploadProgress} setuploaded={setWorkshopUploaded} setUploadFileName={setWorkshopUploadFileName} />}
        {workshopUploaded && <UploadToaster uploaded={workshopUploaded} setuploaded={setWorkshopUploaded} uploadProgress={workshopUploadProgress} setUploadProgress={setWorkshopUploadProgress} fileName={workshopUploadFileName} setUploadFileName={setWorkshopUploadFileName} uploadFailed={workshopUploadFailed} setUploadFailed={setWorkshopUploadFailed} />}
    </div>
  )
}

export default Workshop
